import React from 'react';
import { Box, VStack, HStack, Text } from '@chakra-ui/react';
import WholenessRingSkeleton from './DashboardComponents/WholenessRingSkeleton';
import WholenessOverviewSkeleton from './DashboardComponents/WholenessOverviewSkeleton';

const WholenessRingWithOverviewSkeleton = ({
  title = 'Wholeness Ring & Overview',
  subtitle = 'This graph displays the total scores of your team who have taken the screener over the past 30 days.',
  titleInTopRow = false,
}: {
  title?: string;
  subtitle?: string;
  titleInTopRow?: boolean;
}) => {
  return (
    <VStack width="100%" align="stretch" spacing="30px">
      {titleInTopRow && (
        <VStack>
          <Text variant="loraSectionTitle" textAlign="start">
            {title}
          </Text>
          {subtitle && (
            <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
              {subtitle}
            </Text>
          )}
        </VStack>
      )}
      <HStack
        align="start"
        spacing="180px"
        marginLeft={'30px'}
        marginTop={'10px'}
        w="full"
        flexWrap={{ base: 'wrap', lg: 'nowrap' }}
      >
        <Box flex="1">
          <WholenessRingSkeleton titleShown={!titleInTopRow} />
        </Box>
        <VStack spacing="30px" align="stretch" flex="0.6" maxWidth="410px" height={'640px'}>
          <WholenessOverviewSkeleton />
        </VStack>
      </HStack>
    </VStack>
  );
};

export default WholenessRingWithOverviewSkeleton;
